import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import goToConfirmation from './modules/goToConfirmation';
import SendEmailAgain from './modules/SendEmailAgain';
import ChangeUser from './modules/ChangeUser';
import ShowNumbers from './modules/ShowNumbers';
import DownloadReport from './modules/DownloadReport';
import ClearName from './modules/ClearName';
import Whatsapp from 'src/components/Whatsapp';
import sendWhatsapp from './modules/SendWhatsapp';
interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

const InvitationConfirmation: React.FC = () => {
  const endpoint = '/invitation-confirmation';
  const title = 'Envios de campanha';

  const { projectHash, eventHash } = useParams<IParams>(); const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },
    vip_category: { ref: 'vip_category', column: 'vip_category', label: 'CATEGORIA VIP' },
    user_hash: {
      ref: 'user_hash',
      column: 'user_hash',
      label: 'Hash do usuário',
      show: false,
    },
    project_id: {
      ref: 'project_id',
      column: 'project_id',
      label: 'Projeto',
      show: false,
    },
    name: {
      ref: 'name',
      column: 'name',
      label: 'Nome',

    },
    invitation_id: {
      ref: 'invitation_id',
      column: 'invitation_id',
      label: 'Convite',
      show: false,

    },
    email: {
      ref: 'email',
      column: 'email',
      label: 'E-mail',

    },
    phone: {
      ref: 'phone',
      column: 'phone',
      label: 'Telefone',

    },

    confirmated: {
      ref: 'confirmated',
      column: 'confirmated',
      label: 'Enviado?',

    },

    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {

    table: {
      model: 'input',
      type: 'text',
      name: 'table',
      label: 'Mesa',
    },
    name: {
      model: 'input',
      type: 'text',
      name: 'name',
      label: 'Nome',
    },
    email: {
      model: 'input',
      type: 'text',
      name: 'email',
      label: 'E-mail',
    },
    phone: {
      model: 'input',
      type: 'text',
      name: 'phone',
      label: 'Telefone',
    },
    company: {
      model: 'input',
      type: 'text',
      name: 'company',
      label: 'Empresa',
    },
    category_id: {
      model: 'input',
      type: 'text',
      name: 'category_id',
      label: 'Categoria',
    },
    changed_by: {
      model: 'input',
      type: 'text',
      name: 'title',
      label: 'Substituido por',
    },
    confirmated: {
      model: 'selectSimple',
      type: 'text',
      name: 'confirmated',
      label: 'Confirmado',
      options: [
        { label: 'Sim', value: 'Sim' },
        { label: 'Não', value: 'Não' }
      ]
    },
    status: {
      model: 'selectSimple',
      type: 'text',
      name: 'status',
      label: 'Participou?',
      options: [
        { label: 'Sim', value: 'Sim' },
        { label: 'Não', value: 'Não' }
      ]
    },

  };

  const formSchemaUpdate = {
    ...formSchema
  };

  const formValidation: Record<string, ValidationSchema> = {

  };


  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
      () => ShowNumbers(),
      () => DownloadReport(),
      () => ClearName()
    ],
    bodyModules: [


      (lineData: Record<string, any>) => sendWhatsapp({ lineData }),


      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),



      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default InvitationConfirmation;
